/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import axios from 'axios';
import moment from 'moment';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> currentLocale ----------------------------------
    currentLocale: 'de',


    // >>> Flag: AgencyLogin ------------------------------
    flagSharedAgencyLoggedIn: false,
    sharedAgencyLoginResults: {},

    shared_AgencyGetBookings: [],
    shared_AgencyGetBookings_Filtered: [],
    shared_filterSearchAgencyBookingsParams: {
        "searchfor_flightdate": '',
        "searchfor_bookingcode": '',
        "searchfor_invoiceid": '',
        "searchfor_surname": '',
    },

    shared_AgencyTotalBrutto: 0,
    shared_AgencyAgencyTotalBrutto: 0,
    shared_AgencyAgencyCashLimit: 0,
    shared_AgencyBookingsParams: {},

    // >>> Flag: Show Section 'FlightSearchResults' -------
    flagSharedShowFlightSearchResults: false, // CONTROL FLAG - 'Search Results Section'

    // >>> 'Users Search Data' ----------------------------
    bookingDepArprtCode: '',                // Dep Airport FLight Search, Code
    bookingDesArprtCode: '',                // Des Airport FLight Search, Code
    bookingDepArprtName: '',                // Dep Airport FLight Search, Name
    bookingDesArprtName: '',                // Des Airport FLight Search, Name
    bookingDepArprtCode_ReturnToOther: '',  // Dep Airport FLight Search, Code (Return to other)
    bookingDesArprtCode_ReturnToOther: '',  // Des Airport FLight Search, Code (Return to other)
    bookingDepArprtName_ReturnToOther: '',  // Dep Airport FLight Search, Name (Return to other)
    bookingDesArprtName_ReturnToOther: '',  // Des Airport FLight Search, Name (Return to other)

    bookingUsersSearchData: { // Users Search Data
        depAfter: '',
        depArprtCode: '',
        desArprtCode: '',
        limit: '',
        noADT: '',
        noCHD: '',
        noINF: '',
        ojArprtCode: '',
        ojType: '',
        rTrip: '',
        retAfter: '',
    },

    // >>> 'Users FlightSearch Results' -------------------
    bookingFlightSearchResults: {}, // SearchResults
    // >>> 'Users Lockfares Results' ----------------------
    bookingLockfaresResults: {},
    // >>> 'Users Process Results' ------------------------
    bookingProcessBookingResult: {},


    // >>> Seatmap(s) Stuff -------------------------------
    bookingSeatReservationLockingCodeResults: { // saving both Directions
        outward: '',
        return: ''
    },
    bookingSeatPlanOutwardResults: {},
    bookingSeatPlanReturnResults: {},


    // >>> 'Users Cart&More' ------------------------------
    bookingCart: [],
    bookingCartOutwardTotal: 0,
    bookingCartReturnTotal: 0,

    flagBookingOutwardFlightSelected: false, // CONTROL FLAG - Selected 'Outward Flight'
    flagBookingReturnFlightSelected: false, // CONTROL FLAG - Selected 'Return Flight'
    bookingFlightIdSelectedOutward: null, // which selected OUT Flight ID
    bookingFlightIdSelectedReturn: null, // which selected RET Flight ID
    bookingPriceIdSelectedOutward: null, // which selected OUT PRCS ID
    bookingPriceIdSelectedReturn: null, // which selected RET PRCS ID

    bookingSrvcsSeatExistOnOut: false, // does Srvcs Seat exist on OUT?
    bookingSrvcsSeatExistOnRet: false, // does Srvcs Seat exist on Ret?
    bookingSrvcsMealExists: false, // does Srvcs 'MEAL' exist?
    bookingSrvcsServiceExists: false, // does Srvcs 'SERVICE' exist?
    bookingSrvcsPetsExists: false, // does Srvcs 'PETS' exist?
    bookingSrvcsSportbagExists: false, // does Srvcs 'SPORTBAG' exist?
    bookingSrvcsBaggageExists: false, // does Srvcs 'BAGGAGE' exist?
    bookingSrvcsMedicalExists: false, // does Srvcs 'MEDICAL' exist?
    bookingSrvcsInsuranceExists: false, // does Srvcs 'INSURANCE' exist?
    bookingSrvcsInsuranceObject: {}, // Insurance Object itself


    flagBookingPassengersAreReadyForValidation: true, // Passenger(s) are ready ...
    flagBookingPaymentIsReadyForOverview: false, // 'Payment' is ready ...
    flagBookingOverviewIsReadyForProcess: false, // 'Overview' is ready ...

    bookingValidatePassengersObject: {}, // Calls Object to send ..
    bookingProcessBookingObject: {}, // Calls Object to send ..


    // >>> 'Offers' ---------------------------------------
    bookingOffers: {}, // KeyDestinatiosns Offers
    bookingDeparturesKeyDes: [], // KeyDestinatiosns Departure Airports

    bookingOffersSelectedDestination: {}, // User selected Destination
    bookingOffersListFlightsMonthlyOffers: [], // Next 6 Months Prices Offers
    bookingOffersChoosenFlightByUser: null, // User choosen Flight of Offers
    flagSharedShowFlightSearchResultsAndBestPriceCaroussel: false, // CONTROL FLAG - 'Search Results Section and Best Prices'


    // >>> 'Wirecard' -------------------------------------
    bookingWireCardEnrollPaymentResults: {},

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * getCurrentLocale()
    *
    * Desc:
    * Note:
    *
    */
    getCurrentLocale: state => {

        const data = JSON.parse(localStorage.getItem('sdr__lang'));


        if (data === null) {
            return state.currentLocale;
        }
        if (data.value !== null) {
            return state.currentLocale === data.value ? state.currentLocale : data.value;
        }
        // return data.value;

    }, // eof getCurrentLocale()




    /***************************************************************************
    * Getters: Flag: Agency Login
    ***************************************************************************/
    /***************************************************************************
    * getFlagSharedAgencyLoggedIn()
    *
    * Desc:
    * Note:
    *
    */
    getFlagSharedAgencyLoggedIn: state => {

        return state.flagSharedAgencyLoggedIn;

    }, // eof getFlagSharedAgencyLoggedIn()


    /***************************************************************************
    * getSharedAgencyLoginResultsAmountAndValue()
    *
    * Desc: Return Agency Commison&Type. Catch from localStorage. NOT from State.
    * Note: Extract from agency-object in localStorage.
    *
    */
    getSharedAgencyLoginResultsAmountAndValue: state => payload => {

        const ao = JSON.parse(localStorage.getItem('sdr__agency_object')),
            ao2 = JSON.parse(ao.value);


        if (payload === 'services') {
            return ao2.agency_servicecommission_amount + ' ' + ao2.agency_servicecommission_type;
        } else {
            return ao2.agency_commission_amount + ' ' + ao2.agency_commission_type;
        }

    }, // eof getSharedAgencyLoginResultsAmountAndValue()


    /***************************************************************************
    * getSharedAgencyLoginResultsAgencyObject()
    *
    * Desc: Return Agency Object. Catch from localStorage. NOT from State.
    * Note: Extract from agency-object in localStorage.
    *
    */
    getSharedAgencyLoginResultsAgencyObject: state => {

        const ao = JSON.parse(localStorage.getItem('sdr__agency_object'));


        return ao.value;

    }, // eof getSharedAgencyLoginResultsAgencyObject()


    /***************************************************************************
    * get_agencyAuthorizationHeader()
    *
    * Desc: Return ... Catch up (Agency) Auth Header from Ls.
    * Note:
    *
    */
    get_agencyAuthorizationHeader: state => {

        let localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agencyAuthorizationHeader'));


        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            localStorageHeader = JSON.parse(localStorageHeaderData.value);
        }


        return localStorageHeader;

    }, // eo function get_agencyAuthorizationHeader()


    /***************************************************************************
    * get_agencyUsername()
    *
    * Desc:
    * Note:
    *
    */
    get_agencyUsername: state => {

        let localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agency_username'));


        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            // localStorageHeader = JSON.parse(localStorageHeaderData.value);
            localStorageHeader = localStorageHeaderData.value;
        }


        return localStorageHeader;

    }, // eo function get_agencyUsername()


    /***************************************************************************
    * get_agencyPassword()
    *
    * Desc:
    * Note:
    *
    */
    get_agencyPassword: state => {

        let localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agency_password'));


        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            // localStorageHeader = JSON.parse(localStorageHeaderData.value);
            localStorageHeader = localStorageHeaderData.value;
        }


        return localStorageHeader;

    }, // eo function get_agencyPassword()


    /***************************************************************************
    * get_shared_AgencyGetBookings()
    *
    * Desc: Return Agencies 'Get Bookings'.
    * Note:
    *
    */
    get_shared_AgencyGetBookings: state => {

        return state.shared_AgencyGetBookings;

    }, // eof get_shared_AgencyGetBookings()

    /***************************************************************************
    * get_shared_AgencyGetBookings_Filtered()
    *
    * Desc: Return Agencies 'Get Bookings' BUT ... filtered.
    * Note:
    *
    */
    get_shared_AgencyGetBookings_Filtered: state => {

        return state.shared_AgencyGetBookings_Filtered;

    }, // eof get_shared_AgencyGetBookings_Filtered()


    /***************************************************************************
    * get_shared_AgencyTotalBrutto()
    *
    * Desc: Return Agencies 'Total Brutto'
    * Note:
    *
    */
    get_shared_AgencyTotalBrutto: state => {

        return state.shared_AgencyTotalBrutto;

    }, // eof get_shared_AgencyTotalBrutto()


    /***************************************************************************
    * get_shared_AgencyAgencyTotalBrutto()
    *
    * Desc: Return Agencies 'Total Brutto of Agency'
    * Note:
    *
    */
    get_shared_AgencyAgencyTotalBrutto: state => {

        return state.shared_AgencyAgencyTotalBrutto;

    }, // eof get_shared_AgencyAgencyTotalBrutto()


    /***************************************************************************
    * get_shared_AgencyAgencyCashLimit()
    *
    * Desc: Return Agencies 'Cash Limit'
    * Note:
    *
    */
    get_shared_AgencyAgencyCashLimit: state => {

        return state.shared_AgencyAgencyCashLimit;

    }, // eof get_shared_AgencyAgencyCashLimit()


    /***************************************************************************
    * get_shared_AgencyBookingsParams()
    *
    * Desc: Return Agencies Search Params.
    * Note:
    *
    */
    get_shared_AgencyBookingsParams: state => {

        return state.shared_AgencyBookingsParams;

    }, // eof get_shared_AgencyBookingsParams()




    /***************************************************************************
    * Getters: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * getFlagSharedShowFlightSearchResults()
    *
    * Desc: Return Flag: 'Show Flight Search Results Section'
    * Note:
    *
    */
    getFlagSharedShowFlightSearchResults: state => {

        return state.flagSharedShowFlightSearchResults;

    }, // eof getFlagSharedShowFlightSearchResults()




    /***************************************************************************
    * Getters: Users Search
    ***************************************************************************/
    /***************************************************************************
    * getBookingDepArprtCode()
    *
    * Desc: Return DepArprtCode
    * Note: Users Search, Part 1
    *
    */
    getBookingDepArprtCode: state => {

        return state.bookingDepArprtCode;

    }, // eof getBookingDepArprtCode()

    /***************************************************************************
    * getBookingDepArprtName()
    *
    * Desc: Return DepArprtName
    * Note: Users Search, Part 1
    *
    */
    getBookingDepArprtName: state => {

        return state.bookingDepArprtName;

    }, // eof getBookingDepArprtName()

    /***************************************************************************
    * getBookingDesArprtCode()
    *
    * Desc: Return DesArprtCode
    * Note: Users Search, Part 1
    *
    */
    getBookingDesArprtCode: state => {

        return state.bookingDesArprtCode;

    }, // eof getBookingDesArprtCode()

    /***************************************************************************
    * getBookingDesArprtName()
    *
    * Desc: Return DesArprtName
    * Note: Users Search, Part 1
    *
    */
    getBookingDesArprtName: state => {

        return state.bookingDesArprtName;

    }, // eof getBookingDesArprtName()


    /***************************************************************************
    * getBookingDepArprtCodeReturnToOther()
    *
    * Desc: Return DepArprtCode_ReturnToOther;
    * Note:
    *
    */
    getBookingDepArprtCodeReturnToOther: state => {

        return state.bookingDepArprtCode_ReturnToOther;

    }, // eof getBookingDepArprtCodeReturnToOther()

    /***************************************************************************
    * getBookingDepArprtNameReturnToOther()
    *
    * Desc: Return DepArprtName_ReturnToOther;
    * Note:
    *
    */
    getBookingDepArprtNameReturnToOther: state => {

        return state.bookingDepArprtName_ReturnToOther;

    }, // eof getBookingDepArprtNameReturnToOther()


    /***************************************************************************
    * getBookingDesArprtCodeReturnToOther()
    *
    * Desc: Return DesArprtCode_ReturnToOther;
    * Note:
    *
    */
    getBookingDesArprtCodeReturnToOther: state => {

        return state.bookingDesArprtCode_ReturnToOther;

    }, // eof getBookingDesArprtCodeReturnToOther()


    /***************************************************************************
    * getBookingDesArprtNameReturnToOther()
    *
    * Desc: Return DesArprtName_ReturnToOther;
    * Note:
    *
    */
    getBookingDesArprtNameReturnToOther: state => {

        return state.bookingDesArprtName_ReturnToOther;

    }, // eof getBookingDesArprtNameReturnToOther()




    /***************************************************************************
    * getBookingUsersSearchData()
    *
    * Desc: Return entire Users Search Object.
    * Note: Users Search, Part 2
    *
    */
    getBookingUsersSearchData: state => {

        return state.bookingUsersSearchData;

    }, // eof getBookingUsersSearchData()


    /***************************************************************************
    * getBookingUsersSearchData_OjArprtCode()
    *
    * Desc: Return
    * Note:
    *
    */
    getBookingUsersSearchData_OjArprtCode: state => {

        return state.bookingUsersSearchData.ojArprtCode;

    }, // eof getBookingUsersSearchData_OjArprtCode()



    /***************************************************************************
    * Getters: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * getBookingFlightSearchResults()
    *
    * Desc: Return Results of FlightSearch (Calls Response).
    * Note:
    *
    */
    getBookingFlightSearchResults: state => {

        return state.bookingFlightSearchResults;

    }, // eof getBookingFlightSearchResults()


    /***************************************************************************
    * getFlagBookingOutwardFlightSelected()
    *
    * Desc: Is 'Outward Flight' selected.
    * Note:
    *
    */
    getFlagBookingOutwardFlightSelected: state => {

        return state.flagBookingOutwardFlightSelected;

    }, // eof getFlagBookingOutwardFlightSelected()


    /***************************************************************************
    * getFlagBookingReturnFlightSelected()
    *
    * Desc: Is 'Return Flight' selected.
    * Note:
    *
    */
    getFlagBookingReturnFlightSelected: state => {

        return state.flagBookingReturnFlightSelected;

    }, // eof getFlagBookingReturnFlightSelected()


    /***************************************************************************
    * getBookingFlightIdSelectedOutward()
    *
    * Desc: Selected Outward Flight Id.
    * Note:
    *
    */
    getBookingFlightIdSelectedOutward: state => {

        return state.bookingFlightIdSelectedOutward;

    }, // eof getBookingFlightIdSelectedOutward()


    /***************************************************************************
    * getBookingFlightIdSelectedReturn()
    *
    * Desc: Selected Return Flight Id.
    * Note:
    *
    */
    getBookingFlightIdSelectedReturn: state => {

        return state.bookingFlightIdSelectedReturn;

    }, // eof getBookingFlightIdSelectedReturn()


    /***************************************************************************
    * getBookingPriceIdSelectedOutward()
    *
    * Desc: Selected Outward Price Id.
    * Note:
    *
    */
    getBookingPriceIdSelectedOutward: state => {

        return state.bookingPriceIdSelectedOutward;

    }, // eof getBookingPriceIdSelectedOutward()


    /***************************************************************************
    * getBookingPriceIdSelectedReturn()
    *
    * Desc: Selected Return Price Id.
    * Note:
    *
    */
    getBookingPriceIdSelectedReturn: state => {

        return state.bookingPriceIdSelectedReturn;

    }, // eof getBookingPriceIdSelectedReturn()




    /***************************************************************************
    * Getters: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * getBookingLockfaresResults()
    *
    * Desc: Return Results of Lockfares (Calls Response).
    * Note:
    *
    */
    getBookingLockfaresResults: state => {

        return state.bookingLockfaresResults;

    }, // eof getBookingLockfaresResults()


    /***************************************************************************
    * getBookingPassengers()
    *
    * Desc: Returns an Array of 'PassengersTypes'.
    * Note: kop ('AdultWithoutInfant', 'AdultWithInfant', 'Child', 'Nobody')
    * Note: Getter with Paylod
    *
    */
    getBookingPassengers: state => payload => {

        let paxArray = [],
            counter = 1,
            travelsWithInfantNumber = '',
            countADT = parseFloat(state.bookingUsersSearchData.noADT),
            countCHD = parseFloat(state.bookingUsersSearchData.noCHD),
            countINF = parseFloat(state.bookingUsersSearchData.noINF),
            countADTCHD = countADT + countCHD,
            countADTCHDINF = countADTCHD + countINF;


        for (var i = 0; i < state.bookingUsersSearchData.noADT; i++) {
            // >>> ---------------------------------------------------------
            if (countINF === 0) {
                travelsWithInfantNumber = '';
            }

            // >>> ---------------------------------------------------------
            if (countINF !== 0) {
                // >>> Step 1: Catch every Pax Data (INF) ------------------
                for (var x = countADTCHD + 1; x <= countADTCHDINF; x++) {
                    // >>> Arrange adults to a baby ------------------------
                    if (x === parseFloat(counter) + parseFloat(countADTCHD)) {
                        travelsWithInfantNumber = x;
                    }
                }
            }

            paxArray.push({
                type: 'ADT',
                index: counter,
                id_pax: counter,
                kop: travelsWithInfantNumber !== '' ? 'AdultWithInfant' : 'AdultWithoutInfant'
            });
            counter = counter + 1;
            travelsWithInfantNumber = '';
        }
        for (var i = 0; i < state.bookingUsersSearchData.noCHD; i++) {
            paxArray.push({
                type: 'CHD',
                index: counter,
                id_pax: counter,
                kop: 'Child'
            });
            counter = counter + 1;
        }
        if (payload === 'booking') {
            for (var i = 0; i < state.bookingUsersSearchData.noINF; i++) {
                paxArray.push({
                    type: 'INF',
                    index: counter,
                    id_pax: counter,
                    kop: 'Nobody'
                });
                counter = counter + 1;
            }
        }


        return paxArray;

    }, // eof getBookingPassengers()


    /***************************************************************************
    * getBookingPassengersSrvcsService()
    *
    * Desc: Returns an Array of Srvcs 'SERVICE'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsService: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'service') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'service') {
                    let result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getBookingPassengersSrvcsService()


    /***************************************************************************
    * getBookingPassengersSrvcsMeals()
    *
    * Desc: Returns an Array of Srvcs 'MEALS'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsMeals: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'meal') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'meal') {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getBookingPassengersSrvcsMeals()


    /***************************************************************************
    * getBookingPassengersSrvcsPets()
    *
    * Desc: Returns an Array of Srvcs 'PETS'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsPets: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'pets') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'pets') {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getBookingPassengersSrvcsPets()


    /***************************************************************************
    * getBookingPassengersSrvcsSportbag()
    *
    * Desc: Returns an Array of Srvcs 'SPORTBAG'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsSportbag: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'sportbag') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'sportbag') {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;

    }, // eof getBookingPassengersSrvcsSportbag()


    /***************************************************************************
    * getBookingPassengersSrvcsSportbag()
    *
    * Desc: Returns an Array of Srvcs 'BAGGAGE'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsBaggage: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'baggage') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'baggage') {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getBookingPassengersSrvcsBaggage()


    /***************************************************************************
    * getBookingPassengersSrvcsMedical()
    *
    * Desc: Returns an Array of Srvcs 'MEDICAL'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsMedical: state => {

        let srvcsArray = [];


        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'medical') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'medical') {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getBookingPassengersSrvcsMedical()


    /***************************************************************************
    * getBookingSrvcsSeatExistOnOut()
    *
    * Desc: Return 'Srvcs SEAT exist on OUT'.
    * Note:
    *
    */
    getBookingSrvcsSeatExistOnOut: state => {

        return state.bookingSrvcsSeatExistOnOut;

    }, // eof getBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * getBookingSrvcsSeatExistOnRet()
    *
    * Desc: Return 'Srvcs SEAT exist on RET'.
    * Note:
    *
    */
    getBookingSrvcsSeatExistOnRet: state => {

        return state.bookingSrvcsSeatExistOnRet;

    }, // eof getBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * getBookingSrvcsInsuranceExist()
    *
    * Desc: 'Srvcs INSURANCE exists'.
    * Note:
    *
    */
    getBookingSrvcsInsuranceExist: state => {

        return state.bookingSrvcsInsuranceExists;

    }, // eof getBookingSrvcsInsuranceExist()


    /***************************************************************************
    * getBookingSrvcsInsuranceObject()
    *
    * Desc: Returns 'Srvcs INSURANCE' Object.
    * Note:
    *
    */
    getBookingSrvcsInsuranceObject: state => {

        return state.bookingSrvcsInsuranceObject;

    }, // eof getBookingSrvcsInsuranceObject()


    /***************************************************************************
    * getBookingSrvcsMealExists()
    *
    * Desc: Return 'Srvcs MEAL exists?'.
    * Note:
    *
    */
    getBookingSrvcsMealExists: state => {

        return state.bookingSrvcsMealExists;

    }, // eof getBookingSrvcsMealExists()


    /***************************************************************************
    * getBookingSrvcsServiceExists()
    *
    * Desc: Return 'Srvcs SERVICE exists?'.
    * Note:
    *
    */
    getBookingSrvcsServiceExists: state => {

        return state.bookingSrvcsServiceExists;

    }, // eof getBookingSrvcsServiceExists()


    /***************************************************************************
    * getBookingSrvcsPetsExists()
    *
    * Desc: Return 'Srvcs PETS exists?'.
    * Note:
    *
    */
    getBookingSrvcsPetsExists: state => {

        return state.bookingSrvcsPetsExists;

    }, // eof getBookingSrvcsPetsExists()


    /***************************************************************************
    * getBookingSrvcsSportbagExists()
    *
    * Desc: Return 'Srvcs SPORTBAG exists?'.
    * Note:
    *
    */
    getBookingSrvcsSportbagExists: state => {

        return state.bookingSrvcsSportbagExists;

    }, // eof getBookingSrvcsSportbagExists()


    /***************************************************************************
    * getBookingSrvcsBaggageExists()
    *
    * Desc: Return 'Srvcs BAGGAGE exists?'.
    * Note:
    *
    */
    getBookingSrvcsBaggageExists: state => {

        return state.bookingSrvcsBaggageExists;

    }, // eof getBookingSrvcsBaggageExists()


    /***************************************************************************
    * getBookingSrvcsMedicalExists()
    *
    * Desc: Return 'Srvcs MEDICAL exists?'.
    * Note:
    *
    */
    getBookingSrvcsMedicalExists: state => {

        return state.bookingSrvcsMedicalExists;

    }, // eof getBookingSrvcsMedicalExists()


    /***************************************************************************
    * getBookingDoesAnySrvcsExistAtAll()
    *
    * Desc: Return 'we have any srvcs on flight?  With Seats included!'
    * Note:
    *
    */
    getBookingDoesAnySrvcsExistAtAll: state => {


        let srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;


        if (state.bookingLockfaresResults.outwardFlight.services.length === 0 && state.bookingLockfaresResults.outwardFlight.seatServices.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            if (state.bookingLockfaresResults.inboundFlight.services.length === 0 && state.bookingLockfaresResults.inboundFlight.seatServices.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }


        return doesAnySrvcsExistAtAll;

    }, // eof getBookingDoesAnySrvcsExistAtAll()


    /***************************************************************************
    * getBookingDoesAnySrvcsExistAtAllWOSeats()
    *
    * Desc: Return 'we have any srvcs on flight? Without Seats!'
    * Note:
    *
    */
    getBookingDoesAnySrvcsExistAtAllWOSeats: state => {


        let srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;


        if (state.bookingLockfaresResults.outwardFlight.services.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            if (state.bookingLockfaresResults.inboundFlight.services.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }


        return doesAnySrvcsExistAtAll;

    }, // eof getBookingDoesAnySrvcsExistAtAllWOSeats()


    /***************************************************************************
    * getFlagBookingPassengersAreReadyForValidation()
    *
    * Desc: Return Flag: 'Passengers are ready to get validated'
    * Note:
    *
    */
    getFlagBookingPassengersAreReadyForValidation: state => {

        return state.flagBookingPassengersAreReadyForValidation;

    }, // eof getFlagBookingPassengersAreReadyForValidation()




    /***************************************************************************
    * Getters: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * getFlagBookingPaymentIsReadyForOverview()
    *
    * Desc: Return Flag: 'Payment is ready to Step:Overview'
    * Note:
    *
    */
    getFlagBookingPaymentIsReadyForOverview: state => {

        return state.flagBookingPaymentIsReadyForOverview;

    }, // eof getFlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * getBookingValidatePassengersObject()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'.
    * Note:
    *
    */
    getBookingValidatePassengersObject: state => {

        return state.bookingValidatePassengersObject;

    }, // eof getBookingValidatePassengersObject()




    /***************************************************************************
    * Getters: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * getFlagBookingOverviewIsReadyForProcess()
    *
    * Desc: Return Flag: 'Overview is ready to Step:Confirmation'
    * Note:
    *
    */
    getFlagBookingOverviewIsReadyForProcess: state => {

        return state.flagBookingOverviewIsReadyForProcess;

    }, // eof getFlagBookingOverviewIsReadyForProcess()


    /***************************************************************************
    * getBookingProcessBookingObject()
    *
    * Desc: Return 'Object we sent in processBooking Call'.
    * Note:
    *
    */
    getBookingProcessBookingObject: state => {

        return state.bookingProcessBookingObject;

    }, // eof getBookingProcessBookingObject()


    /***************************************************************************
    * getBookingProcessBookingResults()
    *
    * Desc: Return Results of ProcessBooking (Calls Response).
    * Note:
    *
    */
    getBookingProcessBookingResults: state => {

        return state.bookingProcessBookingResults;

    }, // eof getBookingProcessBookingResults()




    /***************************************************************************
    * Getters: 'Seats'
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * getBookingSeatReservationLockingCodeResults()
    *
    * Desc: Return Results of Seats LockingCodes Calls (both).
    * Note:
    *
    */
    getBookingSeatReservationLockingCodeResults: state => {

        return state.bookingSeatReservationLockingCodeResults;

    }, // eof getBookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPlanOutwardResults()
    *
    * Desc: Return Results Seatmap Data Outward.
    * Note:
    *
    */
    getBookingSeatPlanOutwardResults: state => {

        return state.bookingSeatPlanOutwardResults;

    }, // eof getBookingSeatPlanOutwardResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPlanReturnResults()
    *
    * Desc: Return Results Seatmap Data Return.
    * Note:
    *
    */
    getBookingSeatPlanReturnResults: state => {

        return state.bookingSeatPlanReturnResults;

    }, // eof getBookingSeatPlanReturnResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPrice()
    *
    * Desc: Get Price of Seat(type).
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    *
    */
    getBookingSeatPrice: state => payload => {

        let seatPrice = 0;


        // >>> Searching/Adding  ----------------
        if (payload.type === 'outward') {
            state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatPrice = item.price;
                }
            });
        }

        if (payload.type === 'return') {
            state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatPrice = item.price;
                }
            });
        }


        return seatPrice;

    }, // eof getBookingSeatPrice()


    /*************************************************************************** 'Seats'
    * getBookingSeatFreeColor()
    *
    * Desc: Get SeatColor Free of Seat(type).
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    */
    getBookingSeatFreeColor: state => payload => {

        let seatFreeColor = '';


        // >>> Searching ------------------------
        if (payload.type === 'outward') {
            state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatFreeColor = item.colorFree;
                }
            });
        }

        if (payload.type === 'return') {
            state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatFreeColor = item.colorFree;
                }
            });
        }


        return seatFreeColor;

    }, // eof getBookingSeatFreeColor()


    /*************************************************************************** 'Seats'
    * getBookingSeatRemark()
    *
    * Desc: Get 'Remark' of Seat(type). (must be confirmed when booking)
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    *
    */
    getBookingSeatRemark: state => payload => {

        let seatsRemark = '';


        // >>> Searching ------------------------
        if (payload.type === 'outward') {
            state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatsRemark = item.remark !== undefined ? item.remark : '';
                }
            });
        }

        if (payload.type === 'return') {
            state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach((item, i) => {
                if (item.code === payload.seatCode) {
                    seatsRemark = item.remark !== undefined ? item.remark : '';
                }
            });
        }


        return seatsRemark;

    }, // eof getBookingSeatFreeColor()




    /***************************************************************************
    * Getters: Cart
    ***************************************************************************/
    /***************************************************************************
    * getBookingCart()
    *
    * Desc: Return Cart.
    * Note:
    *
    */
    getBookingCart: state => {

        return state.bookingCart;

    }, // eof getBookingCart()


    /***************************************************************************
    * getBookingCartOutwardTotal()
    *
    * Desc: Return Summed up Outward ALL.
    * Note:
    *
    */
    getBookingCartOutwardTotal: state => {

        return state.bookingCartOutwardTotal;

    }, // eof getBookingCartOutwardTotal()


    /***************************************************************************
    * getBookingCartReturnTotal()
    *
    * Desc: Summed up Return ALL
    * Note:
    *
    */
    getBookingCartReturnTotal: state => {

        return state.bookingCartReturnTotal;

    }, // eof getBookingCartReturnTotal()


    /***************************************************************************
    * getBookingCartCountServices()
    *
    * Desc: Check if we have Service in Cart?
    * Note:
    *
    */
    getBookingCartCountServices: state => {

        let cartCountServices = 0;


        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) { // Count SRVCS
                cartCountServices = cartCountServices + 1;
            }

            for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                cartCountServices = cartCountServices + 1;
            }


            if (state.bookingCart[i].outward_seat.seatno !== undefined) { // Count SEATS
                cartCountServices = cartCountServices + 1;
            }

            if (state.bookingCart[i].return_seat.seatno !== undefined) {
                cartCountServices = cartCountServices + 1;
            }
        }


        return cartCountServices;

    }, // eof getBookingCartCountServices()


    /***************************************************************************
    * getBookingCartIsSrvcAlreadyInCart()
    *
    * Desc: Check if Srvcs already exist in Cart?
    * Note: Getter with Payload!
    *
    */
    getBookingCartIsSrvcAlreadyInCart: state => payload => {

        let alreadyInCart = false;


        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Srvcs already in Out?
                for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                    if (state.bookingCart[i].outward_srvcs[x].code === payload.srvcs.code) {
                        alreadyInCart = true;
                    }
                }

                // >>> Or Srvcs already in Ret?
                if (alreadyInCart === false) {
                    for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                        if (state.bookingCart[i].return_srvcs[x].code === payload.srvcs.code) {
                            alreadyInCart = true;
                        }
                    }
                }

            }
        }


        return alreadyInCart;

    }, // eof getBookingCartIsSrvcAlreadyInCart()


    /*************************************************************************** 'Cart - Seats'
    * getBookingCartIsSeatAlreadyReserved()
    *
    * Desc: Check if Seat is already reserved in Cart?
    * Note: Getter with Payload!
    * Note: Returns entire Pax or empty ....
    *
    */
    getBookingCartIsSeatAlreadyReserved: state => payload => {

        let alreadyReservedBy = '';


        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (payload.type === 'outward') {
                if (state.bookingCart[i].outward_seat.seatno === payload.seatName) {
                    alreadyReservedBy = state.bookingCart[i]; // returns entire pax
                }
            }

            if (payload.type === 'return') {
                if (state.bookingCart[i].return_seat.seatno === payload.seatName) {
                    alreadyReservedBy = state.bookingCart[i]; // returns entire pax
                }
            }
        }


        return alreadyReservedBy;

    }, // eof getBookingCartIsSeatAlreadyReserved()


    /***************************************************************************
    * getBookingCartHasPaxAlreadyReservedASeat()
    *
    * Desc: Check if Seat is already reserved in Cart?
    * Note: Getter with Payload!
    * Note: Returns entire Pax or empty ....
    *
    */
    getBookingCartHasPaxAlreadyReservedASeat: state => payload => {

        let paxHasAlreadyReserved = '';


        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                if (payload.type === 'outward') {
                    if (state.bookingCart[i].outward_seat.seatno !== undefined) {
                        paxHasAlreadyReserved = state.bookingCart[i].outward_seat.seatno; // returns seatno
                    }
                }

                if (payload.type === 'return') {
                    if (state.bookingCart[i].return_seat.seatno !== undefined) {
                        paxHasAlreadyReserved = state.bookingCart[i].return_seat.seatno; // returns seatno
                    }
                }

                if (payload.type === 'both') {
                    if (state.bookingCart[i].outward_seat.seatno !== undefined) {
                        paxHasAlreadyReserved = state.bookingCart[i].outward_seat.seatno; // returns seatno
                    }
                    if (paxHasAlreadyReserved === '') {
                        if (state.bookingCart[i].return_seat.seatno !== undefined) {
                            paxHasAlreadyReserved = state.bookingCart[i].return_seat.seatno; // returns seatno
                        }
                    }

                }
            }
        }


        return paxHasAlreadyReserved;

    }, // eof getBookingCartHasPaxAlreadyReservedASeat()


    /***************************************************************************
    * getBookingCartHasPaxAlreadyReservedAnInsurance()
    *
    * Desc:
    * Note:
    */
    getBookingCartHasPaxAlreadyReservedAnInsurance: state => payload => {

        let paxHasAlreadyReserved = false;


        console.log('getBookingCartHasPaxAlreadyReservedAnInsurance')
        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                if (payload.type === 'outward') {
                    console.log(state.bookingCart[i])
                    for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                        if (state.bookingCart[i].outward_srvcs[x].code === 'FLEX OPTION') {
                            paxHasAlreadyReserved = true;
                        }
                    }
                }
            }
        }


        console.log('paxHasAlreadyReserved')
        console.log(paxHasAlreadyReserved)
        return paxHasAlreadyReserved;

    }, // eof getBookingCartHasPaxAlreadyReservedAnInsurance()


    /***************************************************************************
    * getBookingCartSeatsCellId()
    *
    * Desc: Return 'comment' prop from seat in demand?
    * Note: Getter with Payload!
    * Note: Returns 'comment' (cellid).
    *
    */
    getBookingCartSeatsCellId: state => payload => {

        let cellId = '';


        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                if (payload.type === 'outward') {
                    if (state.bookingCart[i].outward_seat.comment !== undefined) {
                        cellId = state.bookingCart[i].outward_seat.comment; // returns comment (cellId)
                    }
                }

                if (payload.type === 'return') {
                    if (state.bookingCart[i].return_seat.comment !== undefined) {
                        cellId = state.bookingCart[i].return_seat.comment; // returns comment (cellId)
                    }
                }
            }
        }


        return cellId;

    }, // eof getBookingCartSeatsCellId()




    /***************************************************************************
    * Getters: Get Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * getOffers()
    *
    * Desc:
    * Note:
    *
    */
    getOffers: state => {

        return state.bookingOffers;

    }, // eof getOffers()


    /***************************************************************************
    * getBookingDeparturesKeyDes()
    *
    * Desc:
    * Note:
    *
    */
    getBookingDeparturesKeyDes: state => {

        if (state.bookingDeparturesKeyDes.destinationsRS !== undefined) {
            return state.bookingDeparturesKeyDes.destinationsRS.des;
        } else {
            return state.bookingDeparturesKeyDes;
        }

    }, // eof getBookingDeparturesKeyDes()


    /***************************************************************************
    * getListOfPaxes()
    *
    * Desc:
    * Note: No State Var here!!!
    *
    */
    getListOfPaxes: state => {

        var listOfPaxes = [
            { "k": 0, "v": "0" },
            { "k": 1, "v": "1" },
            { "k": 2, "v": "2" },
            { "k": 3, "v": "3" },
            { "k": 4, "v": "4" },
            { "k": 5, "v": "5" },
            { "k": 6, "v": "6" },
            { "k": 7, "v": "7" },
            { "k": 8, "v": "8" },
        ];

        return listOfPaxes;

    }, // eof getListOfPaxes()


    /***************************************************************************
    * getOffersSelectedDestination()
    *
    * Desc: Return 'Users selected KeyDeastination'
    * Note:
    *
    */
    getOffersSelectedDestination: state => {

        return state.bookingOffersSelectedDestination;

    }, // eof getOffers()


    /***************************************************************************
    * getBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: Returns ...
    * Note: Fill up Array here .. Push '0' at the end too.
    * Note: // 7th '0' is for right rendering. (starting always with '0').
    *
    */
    getBookingOffersListFlightsMonthlyOffers: state => {

        let monthToSearchFor = moment().month(),
            prices = [0, 0, 0, 0, 0, 0];


        for (var a = 0; a < prices.length; a++) {
            state.bookingOffersListFlightsMonthlyOffers.forEach((flight, i) => {
                if (moment(flight.depDT).month() === monthToSearchFor) {
                    prices[a] = parseFloat(flight.prcs[0].amnt) + parseFloat(flight.prcs[0].tax.tot);;
                }
            });
            if (monthToSearchFor === 11) { // End of Year? => Start with 0
                monthToSearchFor = 0;
            } else {
                monthToSearchFor = monthToSearchFor + 1;
            }
        }

        prices.push(0); // 7th is for right rendering


        return prices;

    }, // eof getBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * getBookingOffersFlightIdViaMonth()
    *
    * Desc: Returns .. Flight via given Month.
    * Note:
    *
    */
    getBookingOffersFlightIdViaMonth: (state, getters) => payload => {

        var currentLocale = getters.getCurrentLocale,
            flightMonthIndex = null,
            foundMonthIndex = null,
            months_en = ['January','February','March','April','May','June','July','August','September','October','November','December'],
            months_de = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];


        if (currentLocale === 'en') {
            foundMonthIndex = months_en.indexOf(payload);
        } else {
            foundMonthIndex = months_de.indexOf(payload);
        }

        // >>> -----------------------------------------------------------------
        state.bookingOffersListFlightsMonthlyOffers.forEach((flight, i) => {
            flightMonthIndex = Number(moment(flight.depDT).month());
            if (flightMonthIndex === foundMonthIndex) {
                state.bookingOffersChoosenFlightByUser = flight;
            }
        });

    }, // eof getBookingOffersFlightIdViaMonth()


    /***************************************************************************
    * getBookingOffersChoosenFlightByUser()
    *
    * Desc: Returns .. Flight choosen by User.
    * Note:
    *
    */
    getBookingOffersChoosenFlightByUser: state =>{

        return state.bookingOffersChoosenFlightByUser;

    }, // eof getBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc:
    * Note:
    *
    */
    getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel: state => {

        return state.flagSharedShowFlightSearchResultsAndBestPriceCaroussel;

    }, // eof getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel()


    /***************************************************************************
    * getBookingWireCardEnrollPaymentResults()
    *
    * Desc:
    * Note:
    *
    */
    getBookingWireCardEnrollPaymentResults: state => {

        return state.bookingWireCardEnrollPaymentResults;

    }, // eof getBookingWireCardEnrollPaymentResults()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetBooking()
    *
    * Desc: Reset State In Context:Booking.
    * Note:
    * TODO: Reset more.
    *
    */
    mut_set_stateResetBooking: (context, payload) => {

        state.bookingUsersSearchData = { // Users Search Data
            depAfter: '',
            depArprtCode: '',
            desArprtCode: '',
            limit: '',
            noADT: '',
            noCHD: '',
            noINF: '',
            ojArprtCode: '',
            ojType: '',
            rTrip: '',
            retAfter: '',
        };

        state.bookingCart = []; // Cart

        state.flagBookingOutwardFlightSelected = false; // CONTROL FLAG - Selected 'Outward Flight'
        state.flagBookingReturnFlightSelected = false; // CONTROL FLAG - Selected 'Return Flight'

    }, // eof mut_set_stateResetBooking()



    /***************************************************************************
    * Mutations: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * mut_setCurrentLocale()
    *
    * Desc: SET State/Flag
    * Note:
    *
    */
    mut_setCurrentLocale: (state, payload) => {

        state.currentLocale = payload;

    }, // eof mut_setCurrentLocale()




    /***************************************************************************
    * Mutations: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagSharedShowFlightSearchResults()
    *
    * Desc: SET State/Flag 'Show Flight Search Results Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagSharedShowFlightSearchResults: (state, payload) => {

        state.flagSharedShowFlightSearchResults = payload;

    }, // eof mut_FlagSharedShowFlightSearchResults()




    /***************************************************************************
    * Mutations: Users Search
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingAirports()
    *
    * Desc: SET States Search Airports (Part 1)
    * Note: ATTENTION: USE 'bookingDepArprtCode' for OUTWARD on 'return to other'
    *
    */
    mut_setBookingAirports: (state, payload) => {

        state.bookingDepArprtCode = payload.depArprtCode;
        state.bookingDepArprtName = payload.depArprtName;
        state.bookingDesArprtCode = payload.desArprtCode;
        state.bookingDesArprtName = payload.desArprtName;
        // >>> 'Return to other'
        state.bookingDepArprtCode_ReturnToOther = payload.depArprtCode_returntoother ? payload.depArprtCode_returntoother : payload.depArprtCode;
        state.bookingDepArprtName_ReturnToOther = payload.depArprtName_returntoother ? payload.depArprtName_returntoother : payload.depArprtName;
        state.bookingDesArprtCode_ReturnToOther = payload.desArprtCode_returntoother ? payload.desArprtCode_returntoother : payload.desArprtCode;
        state.bookingDesArprtName_ReturnToOther = payload.desArprtName_returntoother ? payload.desArprtName_returntoother : payload.desArprtName;

    }, // eof mut_setBookingAirports()


    /***************************************************************************
    * mut_setBookingUsersSearchData()
    *
    * Desc: ACTION 'SET Users Search Data' (Part 2)
    * Note:
    *
    */
    mut_setBookingUsersSearchData: (state, payload) => {

        state.bookingUsersSearchData = {
            depAfter: payload.depAfter,
            depArprtCode: payload.depArprtCode,
            desArprtCode: payload.desArprtCode,
            limit: payload.limit,
            noADT: payload.noADT,
            noCHD: payload.noCHD,
            noINF: payload.noINF,
            ojArprtCode: payload.ojArprtCode,
            ojType: payload.ojType,
            rTrip: payload.rTrip,
            retAfter: payload.retAfter
        };

    }, // eof mut_setBookingUsersSearchData()




    /***************************************************************************
    * Mutations: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingFlightSearchResults()
    *
    * Desc: SET State 'Search Results' Object
    * Note:
    *
    */
    mut_setBookingFlightSearchResults: (state, payload) => {

        state.bookingFlightSearchResults = payload;

    }, // eof mut_setBookingFlightSearchResults()


    /***************************************************************************
    * mut_FlagBookingOutwardFlightSelected()
    *
    * Desc: SET State 'Outward Flight selected' Object.
    * Note:
    *
    */
    mut_FlagBookingOutwardFlightSelected: (state, payload) => {

        state.flagBookingOutwardFlightSelected = payload;

    }, // eof mut_FlagBookingOutwardFlightSelected()


    /***************************************************************************
    * mut_FlagBookingReturnFlightSelected()
    *
    * Desc: SET State 'Return Flight selected' Object.
    * Note:
    *
    */
    mut_FlagBookingReturnFlightSelected: (state, payload) => {

        state.flagBookingReturnFlightSelected = payload;

    }, // eof mut_FlagBookingReturnFlightSelected()


    /***************************************************************************
    * mut_setBookingFlightIdSelectedOutward()
    *
    * Desc: SET State 'Outward Flight Id'.
    * Note:
    *
    */
    mut_setBookingFlightIdSelectedOutward: (state, payload) => {

        state.bookingFlightIdSelectedOutward = payload;

    }, // eof mut_setBookingFlightIdSelectedOutward()


    /***************************************************************************
    * mut_setBookingFlightIdSelectedReturn()
    *
    * Desc: SET State 'Return Flight Id'.
    * Note:
    *
    */
    mut_setBookingFlightIdSelectedReturn: (state, payload) => {

        state.bookingFlightIdSelectedReturn = payload;

    }, // eof mut_setBookingFlightIdSelectedReturn()




    /***************************************************************************
    * Mutations: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingLockfaresResults()
    *
    * Desc: SET State 'Lockfares' Object/Results.
    * Note: SET States if singe Srvcs Cats (exits at all?),
    *
    */
    mut_setBookingLockfaresResults: (state, payload) => {

        // >>> Save calls response --------------
        state.bookingLockfaresResults = payload;

        // >>> State of Srvcs -------------------
        if (payload.inboundFlight !== null) {

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'meal') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'meal') !== undefined) {
                state.bookingSrvcsMealExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'service') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'service') !== undefined) {
                state.bookingSrvcsServiceExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined) {
                state.bookingSrvcsPetsExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'sportbag') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined) {
                state.bookingSrvcsSportbagExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'baggage') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'baggage') !== undefined) {
                state.bookingSrvcsBaggageExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'medical') !== undefined || payload.inboundFlight.services.find(srvcs => srvcs.categoryCode === 'medical') !== undefined) {
                state.bookingSrvcsMedicalExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'insurance') !== undefined) {
                state.bookingSrvcsInsuranceExists = true;
                state.bookingSrvcsInsuranceObject = payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'insurance');
            }

        } else {

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'meal') !== undefined) {
                state.bookingSrvcsMealExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'service') !== undefined) {
                state.bookingSrvcsServiceExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined) {
                state.bookingSrvcsPetsExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'sportbag') !== undefined) {
                state.bookingSrvcsSportbagExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'baggage') !== undefined) {
                state.bookingSrvcsBaggageExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'medical') !== undefined) {
                state.bookingSrvcsMedicalExists = true;
            }

            if (payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'insurance') !== undefined) {
                state.bookingSrvcsInsuranceExists = true;
                state.bookingSrvcsInsuranceObject = payload.outwardFlight.services.find(srvcs => srvcs.categoryCode === 'insurance');
            }

        }

    }, // eof mut_setBookingLockfaresResults()


    /***************************************************************************
    * mut_setBookingSrvcsSeatExistOnOut()
    *
    * Desc: SET State 'Srvcs Seat exits on OUT' Boolean.
    * Note:
    *
    */
    mut_setBookingSrvcsSeatExistOnOut: (state, payload) => {

        state.bookingSrvcsSeatExistOnOut = payload;

    }, // eof mut_setBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * mut_setBookingSrvcsSeatExistOnRet()
    *
    * Desc: SET State 'Srvcs Seat exits on OUT' Boolean.
    * Note:
    *
    */
    mut_setBookingSrvcsSeatExistOnRet: (state, payload) => {

        state.bookingSrvcsSeatExistOnRet = payload;

    }, // eof mut_setBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * mut_setBookingValidatePassengersObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setBookingValidatePassengersObject: (state, payload) => {

        state.bookingValidatePassengersObject = payload;

    }, // eof mut_setBookingValidatePassengersObject()




    /***************************************************************************
    * Mutations: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagBookingPaymentIsReadyForOverview()
    *
    * Desc: SET State 'Payment is ready for Overview?' Boolean.
    * Note:
    *
    */
    mut_FlagBookingPaymentIsReadyForOverview: (state, payload) => {

        state.flagBookingPaymentIsReadyForOverview = payload;

    }, // eof mut_FlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * mut_setBookingProcessBookingObject()
    *
    * Desc: SET State 'Calls Object to send' (processBooking).
    * Note: Saves the Params itself.
    *
    */
    mut_setBookingProcessBookingObject: (state, payload) => {

        state.bookingProcessBookingObject = payload;

    }, // eof mut_setBookingProcessBookingObject()




    /***************************************************************************
    * Mutations: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagBookingOverviewIsReadyForProcess()
    *
    * Desc: SET State 'Overview is ready for Proicess?' Boolean.
    * Note:
    *
    */
    mut_FlagBookingOverviewIsReadyForProcess: (state, payload) => {

        state.flagBookingOverviewIsReadyForProcess = payload;

    }, // eof mut_FlagBookingOverviewIsReadyForProcess()


    /***************************************************************************
    * mut_setBookingProcessBookingResults()
    *
    * Desc: SET State 'processBooking' Object/Results.
    * Note:
    *
    */
    mut_setBookingProcessBookingResults: (state, payload) => {

        // >>> Save calls response --------------
        state.bookingProcessBookingResults = payload;

    }, // eof mut_setBookingProcessBookingResults()




    /***************************************************************************
    * Mutations: Seats
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * mut_setBookingSeatReservationLockingCodeResults()
    *
    * Desc: SET State 'Seats Lockingcodes' (/seatplan/lock/).
    * Note: Saves the Codes/Params/Response itself.
    *
    */
    mut_setBookingSeatReservationLockingCodeResults: (state, payload) => {

        if (payload.type === 'out') {
            state.bookingSeatReservationLockingCodeResults.outward = payload;
        }
        if (payload.type === 'ret') {
            state.bookingSeatReservationLockingCodeResults.return = payload;
        }

    }, // eof mut_setBookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * mut_setBookingSeatReservationLockingCodeResults()
    *
    * Desc: SET State 'Seatplan' (/seatplan/).
    * Note: Saves the Codes/Params/Response itself.
    *
    */
    mut_setBookingSeatplanResults: (state, payload) => {

        if (payload.type === 'out') {
            state.bookingSeatPlanOutwardResults = payload.response;
        }
        if (payload.type === 'ret') {
            state.bookingSeatPlanReturnResults = payload.response;
        }

    }, // eof mut_setBookingSeatplanResults()




    /***************************************************************************
    * Mutations: Cart / Prefill / Update
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingPrefillCart()
    *
    * Desc: PreFill Cart (Skeleton-Object),
    * Note: Attention: To stay reactive the 'state.bookingCart' needs
    * to have all its Parts already at the Beginning.
    *
    */
    mut_setBookingPrefillCart: (state, payload) => {

        let pax = {},
            counter = 1;


        // >>> PreFill Cart --------------------
        state.bookingCart = []; // reset
        state.bookingCartOutwardTotal = 0;
        state.bookingCartReturnTotal = 0;

        for (var i = 0; i < payload.noADT; i++) {
            pax = {
                id: 'adt' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'ADT',
                typeWritten: 'Adult',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }

        for (var i = 0; i < payload.noCHD; i++) {
            pax = {
                id: 'chd' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'CHD',
                typeWritten: 'Child',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }

        for (var i = 0; i < payload.noINF; i++) {
            pax = {
                id: 'inf' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'INF',
                typeWritten: 'Infant',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }

    }, // eof mut_setBookingPrefillCart()


    /***************************************************************************
    * mut_setBookingUpdateCart()
    *
    * Desc: Update Cart/Totals. (on 'Select Flight')
    * Note: New: Sundair, Inf wo. Tax
    * Note: Watches 'modulo'!
    *
    */
    mut_setBookingUpdateCart: (state, payload) => {

        let price = 0,
            totalprice = 0,
            totalpriceoutward = 0,
            totalpricereturn = 0;


        // >>> Update 'Cart' --------------------------------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {

            // >>> ------------------------------ 'booking
            if (payload.modulo === 'booking') {

                if (state.bookingCart[i].type === 'INF') {
                    price = payload.flight.prcs[0].amntInf;
                    totalprice = parseFloat(payload.flight.prcs[0].amntInf);
                } else if (state.bookingCart[i].type === 'CHD') {
                    price = payload.flight.prcs[0].amntRedcd;
                    totalprice = parseFloat(payload.flight.prcs[0].amntRedcd) + parseFloat(payload.flight.prcs[0].tax.tot);
                } else {
                    price = payload.flight.prcs[0].amnt;
                    totalprice = parseFloat(payload.flight.prcs[0].amnt) + parseFloat(payload.flight.prcs[0].tax.tot);
                }


                // >>> Outward Object -----------
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: payload.flight.prcs[0].tax // taxes only
                    };
                    totalpriceoutward = parseFloat(totalpriceoutward) + parseFloat(totalprice);
                }
                // >>> Return Object ------------
                if (payload.type === 'return') {
                    state.bookingCart[i].return = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: payload.flight.prcs[0].tax // taxes only
                    };
                    totalpricereturn = parseFloat(totalpricereturn) + parseFloat(totalprice);
                }

            }


            // >>> ------------------------------ 'services'
            if (payload.modulo === 'services') {

                if (state.bookingCart[i].type === 'INF') {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                } else if (state.bookingCart[i].type === 'CHD') {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                } else {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                }


                // >>> Outward Object -----------
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: 0 // taxes only // useful?
                    };
                    totalpriceoutward = parseFloat(totalpriceoutward) + parseFloat(totalprice);
                }
                // >>> Return Object ------------
                if (payload.type === 'return') {
                    state.bookingCart[i].return = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: 0 // taxes only // useful?
                    };
                    totalpricereturn = parseFloat(totalpricereturn) + parseFloat(totalprice);
                }

            }

        }
        // <<< Update 'Cart' --------------------------------------------------




        // >>> Update 'Totals' ------------------------------------------------
        // >>> ---------------------------------- 'booking'
        if (payload.modulo === 'booking') {

            if (payload.type === 'outward') {
                state.flagBookingOutwardFlightSelected = true;

                state.bookingCartOutwardTotal = totalpriceoutward;
                state.bookingFlightIdSelectedOutward = payload.flight.id;
                state.bookingPriceIdSelectedOutward = payload.flight.prcs[0].id;
            }
            if (payload.type === 'return') {
                state.flagBookingReturnFlightSelected = true;

                state.bookingCartReturnTotal = totalpricereturn;
                state.bookingFlightIdSelectedReturn = payload.flight.id;
                state.bookingPriceIdSelectedReturn = payload.flight.prcs[0].id;
            }

        }


        // >>> ---------------------------------- 'services'
        if (payload.modulo === 'services') {

            if (payload.type === 'outward') {
                state.flagBookingOutwardFlightSelected = true;

                state.bookingCartOutwardTotal = 0; // useful?
                state.bookingFlightIdSelectedOutward = payload.flight.id;
                state.bookingPriceIdSelectedOutward = null; // useful?
            }
            if (payload.type === 'return') {
                state.flagBookingReturnFlightSelected = true;

                state.bookingCartReturnTotal = 0; // useful?
                state.bookingFlightIdSelectedReturn = payload.flight.id;
                state.bookingPriceIdSelectedReturn = null; // useful?
            }

        }
        // <<< Update 'Totals' ------------------------------------------------

    }, // eof mut_setBookingUpdateCart()


    /***************************************************************************
    * mut_setBookingUpdateCartWithSrvcs()
    *
    * Desc: Update Cart/Totals. (on 'Select Srvcs')
    * Note: Add Srvcs, Update Out/Ret Totals.
    * Note: Add 'FLEX OPTION' only on oubound Flight.
    *
    */
    mut_setBookingUpdateCartWithSrvcs: (state, payload) => {

        let totalpriceoutward = 0,
            totalpricereturn = 0;


        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Srvcs for Out? Add to Cart!
                if (payload.srvcs.userInputSrvcsDetails_ToggleOut === true) {
                    state.bookingCart[i].outward_srvcs.push({
                        code: payload.srvcs.code,
                        description: payload.srvcs.description,
                        id: payload.srvcs.id,
                        maxBookablePax: payload.srvcs.maxBookablePax,
                        price: payload.srvcs.price,
                        remark: payload.srvcs.remark,
                        srvc_exist_out: payload.srvcs.srvc_exist_out,
                        srvc_exist_ret: payload.srvcs.srvc_exist_ret,
                        userInputSrvcsDetails_Count: payload.srvcs.userInputSrvcsDetails_Count,
                        userInputSrvcsDetails_ToggleOut: payload.srvcs.userInputSrvcsDetails_ToggleOut,
                        userInputSrvcsDetails_ToggleRet: payload.srvcs.userInputSrvcsDetails_ToggleRet,
                        userInputSrvcsDetails_Comment: payload.srvcs.userInputSrvcsDetails_Comment
                    });
                    totalpriceoutward = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) + parseFloat(totalpriceoutward);
                }

                // >>> Srvcs for Ret? Add to Cart!
                if (payload.srvcs.userInputSrvcsDetails_ToggleRet === true) {
                    if (payload.srvcs.code !== 'FLEX OPTION') { // See Note:
                        state.bookingCart[i].return_srvcs.push({
                            code: payload.srvcs.code,
                            description: payload.srvcs.description,
                            id: payload.srvcs.id,
                            maxBookablePax: payload.srvcs.maxBookablePax,
                            price: payload.srvcs.price,
                            remark: payload.srvcs.remark,
                            srvc_exist_out: payload.srvcs.srvc_exist_out,
                            srvc_exist_ret: payload.srvcs.srvc_exist_ret,
                            userInputSrvcsDetails_Count: payload.srvcs.userInputSrvcsDetails_Count,
                            userInputSrvcsDetails_ToggleOut: payload.srvcs.userInputSrvcsDetails_ToggleOut,
                            userInputSrvcsDetails_ToggleRet: payload.srvcs.userInputSrvcsDetails_ToggleRet,
                            userInputSrvcsDetails_Comment: payload.srvcs.userInputSrvcsDetails_Comment
                        });
                        totalpricereturn = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                        state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) + parseFloat(totalpricereturn);
                    }
                }
            }
        }

    }, // eof mut_setBookingUpdateCartWithSrvcs()


    /***************************************************************************
    * mut_setBookingUpdateCartWithSeat()
    *
    * Desc: Update Cart/Totals. (add  'Seat')
    * Note: Add Seat, Update Out/Ret Totals.
    *
    */
    mut_setBookingUpdateCartWithSeat: (state, payload) => {

        let totalpriceoutward = 0,
            totalpricereturn = 0;


        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Seat for Out? Add to Cart!
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward_seat = payload;
                    totalpriceoutward = parseFloat(payload.price);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) + parseFloat(totalpriceoutward);
                }

                // >>> Seat for Out? Add to Cart!
                if (payload.type === 'return') {
                    state.bookingCart[i].return_seat = payload;
                    totalpricereturn = parseFloat(payload.price);
                    state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) + parseFloat(totalpricereturn);
                }
            }
        }

    }, // eof mut_setBookingUpdateCartWithSeat()


    /***************************************************************************
    * mut_setBookingUpdateCartWithPaxCredentials()
    *
    * Desc: Update Cart with Pax Credentials.
    * Note: Add Firstname & Co.
    * Note: Built in 'onSubmit' for 'validatePassenger' Call.
    *
    */
    mut_setBookingUpdateCartWithPaxCredentials: (state, payload) => {

        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            for (var a = 0; a < payload.passengers.length; a++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.passengers[a].id_pax, 10)) {
                    state.bookingCart[i].paxCredentials = {
                        birthdate: payload.passengers[a].birthdate,
                        firstName: payload.passengers[a].firstName,
                        gender: payload.passengers[a].gender,
                        lastName: payload.passengers[a].lastName,
                        middleName: payload.passengers[a].middleName,
                        salutation: payload.passengers[a].salutation,
                    };
                }
            }
        }

    }, // eof mut_setBookingUpdateCartWithPaxCredentials()


    /***************************************************************************
    * mut_setBookingUpdateCartViaDeleteSrvcs()
    *
    * Desc: Update Cart/Totals. (on 'Delete Srvcs')
    * Note: Delete 'Srvcs'. Update Out/Ret Totals.
    * Note: payload::{ id_pax: pax.id_pax, srvcs: srvcs, type: 'return' }
    * Note: Manipulate State: bookingValidatePassengersObject here too!
    *
    */
    mut_setBookingUpdateCartViaDeleteSrvcs: (state, payload) => {

        let totalpriceoutward = 0,
            totalpricereturn = 0,
            bookingValidatePassengersObject_Clone = { ...state.bookingValidatePassengersObject }; // copy


        // >>> A: Update 'Cart' ---------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                if (payload.type === 'outward') {
                    for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                        if (state.bookingCart[i].outward_srvcs[x].id === payload.srvcs.id) {
                            state.bookingCart[i].outward_srvcs.splice(x, 1);
                            totalpriceoutward = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                            state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) - parseFloat(totalpriceoutward);
                        }
                    }
                }

                if (payload.type === 'return') {
                    for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                        if (state.bookingCart[i].return_srvcs[x].id === payload.srvcs.id) {
                            state.bookingCart[i].return_srvcs.splice(x, 1);
                            totalpricereturn = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                            state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) - parseFloat(totalpricereturn);
                        }
                    }
                }
            }
        }


        // >>> B: 'bookingValidatePassengersObject' -------
        if (Object.keys(bookingValidatePassengersObject_Clone.length !== 0)) { // got Data (before validate!)?
            for (var i = 0; i < bookingValidatePassengersObject_Clone.passengers.length; i++) {
                if (parseFloat(bookingValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    for (var x = 0; x < bookingValidatePassengersObject_Clone.passengers[i].services.length; x++) {
                        if (bookingValidatePassengersObject_Clone.passengers[i].services[x].code === payload.srvcs.code) {
                            if (payload.type === 'outward') {
                                if (bookingValidatePassengersObject_Clone.passengers[i].services[x].idFlight === state.bookingFlightIdSelectedOutward) {
                                    bookingValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                }
                            }

                            if (payload.type === 'return') {
                                if (bookingValidatePassengersObject_Clone.passengers[i].services[x].idFlight === state.bookingFlightIdSelectedReturn) {
                                    bookingValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                }
                            }
                        }
                    }
                }
            }
        }


        state.bookingValidatePassengersObject = bookingValidatePassengersObject_Clone; // write back

    }, // eo function mut_setBookingUpdateCartViaDeleteSrvcs()


    /***************************************************************************
    * mut_setBookingUpdateCartViaDeleteSeat()
    *
    * Desc: Update Cart/Totals. ((on 'Delete Seat')
    * Note: Delete 'Seat'. Update Out/Ret Totals.
    * Note: payload::{ id_pax: id_pax, type: type }
    * Note: Manipulate State: bookingValidatePassengersObject here too!
    *
    */
    mut_setBookingUpdateCartViaDeleteSeat: (state, payload) => {

        let totalpriceoutward = 0,
            totalpricereturn = 0,
            bookingValidatePassengersObject_Clone = { ...state.bookingValidatePassengersObject }; // copy


        // >>> A: Update 'Cart' ---------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Seat for Out? Delete from Cart!
                if (payload.type === 'outward') {
                    totalpriceoutward = parseFloat(state.bookingCart[i].outward_seat.price);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) - parseFloat(totalpriceoutward);
                    state.bookingCart[i].outward_seat = {}; // delete
                }

                // >>> Seat for Out? Delete from Cart!
                if (payload.type === 'return') {
                    totalpricereturn = parseFloat(state.bookingCart[i].return_seat.price);
                    state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) - parseFloat(totalpricereturn);
                    state.bookingCart[i].return_seat = {}; // delete
                }
            }
        }


        // >>> B: 'bookingValidatePassengersObject' -------
        if (Object.keys(bookingValidatePassengersObject_Clone).length !== 0) { // got Data (before validate!)?
            for (var i = 0; i < bookingValidatePassengersObject_Clone.passengers.length; i++) {
                if (parseFloat(bookingValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    for (var x = 0; x < bookingValidatePassengersObject_Clone.passengers[i].seatServices.length; x++) {
                        if (payload.type === 'outward') {
                            if (bookingValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === state.bookingFlightIdSelectedOutward) {
                                bookingValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                            }
                        }

                        if (payload.type === 'return') {
                            if (bookingValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === state.bookingFlightIdSelectedReturn) {
                                bookingValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                            }
                        }
                    }
                }
            }
        }


        state.bookingValidatePassengersObject = bookingValidatePassengersObject_Clone; // write back

    }, // eo function mut_setBookingUpdateCartViaDeleteSeat()




    /***************************************************************************
    * Mutations: Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * mut_setOffers()
    *
    * Desc:
    * Note:
    *
    */
    mut_setOffers: (state, payload) => {

        state.bookingOffers = payload.response;

    }, // eof mut_setOffers()


    /***************************************************************************
    * mut_call_DeparturesKeyDes()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_DeparturesKeyDes: (state, payload) => {

        state.bookingDeparturesKeyDes = payload.response;

    }, // eof mut_call_DeparturesKeyDes()


    /***************************************************************************
    * mut_setBookingOffersSelectedDestination()
    *
    * Desc:
    * Note:
    *
    */
    mut_setBookingOffersSelectedDestination: (state, payload) => {

        state.bookingOffersSelectedDestination = payload;

    }, // eof mut_setBookingOffersSelectedDestination()


    /***************************************************************************
    * mut_call_ListFlightsMonthlyOffers()
    *
    * Desc: Sets / Saves Calls Response
    * Note:
    *
    */
    mut_call_ListFlightsMonthlyOffers: (state, payload) => {

        state.bookingOffersListFlightsMonthlyOffers = payload;

    }, // eof mut_call_ListFlightsMonthlyOffers()


    /***************************************************************************
    * mut_setBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: Sets / Saves / Reset
    * Note:
    *
    */
    mut_setBookingOffersListFlightsMonthlyOffers: (state, payload) => {

        state.bookingOffersListFlightsMonthlyOffers = payload;

    }, // eof mut_setBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * mut_setBookingOffersChoosenFlightByUser()
    *
    * Desc: Sets / Saves / Reset
    * Note:
    *
    */
    mut_setBookingOffersChoosenFlightByUser: (state, payload) => {

        state.bookingOffersChoosenFlightByUser = payload;

    }, // eof mut_setBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc: Flag
    * Note:
    *
    */
    mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel: (state, payload) => {

        state.flagSharedShowFlightSearchResultsAndBestPriceCaroussel = payload;

    }, // eof mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()




    /***************************************************************************
    * Mutations: Agency login
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagSharedAgencyLoggedIn()
    *
    * Desc: Flag: Agency logged in?
    * Note:
    *
    */
    mut_FlagSharedAgencyLoggedIn: (state, payload) => {

        state.flagSharedAgencyLoggedIn = payload;

    }, // eof mut_FlagSharedAgencyLoggedIn()


    /***************************************************************************
    * mut_call_GetAgency()
    *
    * Desc: Save Agency Login - Data.
    * Note:
    *
    */
    mut_call_GetAgency: (state, payload) => {

        state.sharedAgencyLoginResults = payload.response;

    }, // eof mut_call_GetAgency()



    /***************************************************************************
    * mut_set_AgencyBookingsParams()
    *
    * Desc: Save Agency Data Search Params.
    * Note:
    *
    */
    mut_set_AgencyBookingsParams: (state, payload) => {

        state.shared_AgencyBookingsParams = payload;

    }, // eof mut_set_AgencyBookingsParams()


    /***************************************************************************
    * mut_call_GetAgencyBookings()
    *
    * Desc: Save Agency Data. Booking History. And Total Brutto.
    * Note: Copy it for Filtered.
    *
    */
    mut_call_GetAgencyBookings: (state, payload) => {

        state.shared_AgencyGetBookings = payload.response.bookings;
        state.shared_AgencyGetBookings.sort((a, b) => (new Date(a.addendum.bookingDate) < new Date(b.addendum.bookingDate)) ? 1 : ((new Date(b.addendum.bookingDate) < new Date(a.addendum.bookingDate)) ? -1 : 0));

        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings; // copy it here

        state.shared_AgencyTotalBrutto = payload.response.totalBrutto;
        state.shared_AgencyAgencyTotalBrutto = payload.response.agencytotalBrutto;
        state.shared_AgencyAgencyCashLimit = payload.response.cashLimit;

    }, // eof mut_call_GetAgencyBookings()



    /***************************************************************************
    * mut_set_filterSearchAgencyBookingsParams()
    *
    * Desc: Set Serch/Filöter Terms. Filter right afterwards.
    * Note:
    *
    */
    mut_set_filterSearchAgencyBookingsParams: (state, payload) => {

        state.shared_filterSearchAgencyBookingsParams = payload.payload;
        payload.context.commit('mut_filterSearchAgencyBookings'); // now filter

    }, // eof mut_set_filterSearchAgencyBookingsParams()


    /***************************************************************************
    * mut_filterSearchAgencyBookings()
    *
    * Desc:
    * Note:
    * Note: shared_filterSearchAgencyBookingsParams: {
    *           "searchfor_flightdate": '',
    *           "searchfor_bookingcode": '',
    *           "searchfor_invoiceid": '',
    *           "searchfor_surname": '',
    *       }
    */
    mut_filterSearchAgencyBookings: (state, payload) => {

        const filterFlightdate = (booking) => {
            let applyFilter = false;


            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate !== '') {
                if (booking.outwardFlights.length > 0) {
                    booking.outwardFlights.forEach(flight => {
                        if (String(flight.departureDateTime.substr(0, 10)) === String(state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate.substr(0, 10))) {
                            applyFilter = true;
                        }
                    });
                }
                if (booking.inboundFlights.length > 0) {
                    booking.inboundFlights.forEach(flight => {
                        if (String(flight.departureDateTime.substr(0, 10)) === String(state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate.substr(0, 10))) {
                            applyFilter = true;
                        }
                    });
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }


            return applyFilter;
        };

        const filterBookingcode = (booking) => {
            let applyFilter = false;


            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode !== '') {
                if (booking.addendum.bookingNo.match(new RegExp(state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode, 'i'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode  === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterInvoiceid = (booking) => {
            let applyFilter = false;


            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid !== '') {
                if (+booking.addendum.idInvoice === +state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        const filterSurname = (booking) => {
            let applyFilter = false;


            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_surname !== '') {
                if (booking.passengers.length > 0) {
                    booking.passengers.forEach(passenger => {
                        if (passenger.lastName.match(new RegExp(state.shared_filterSearchAgencyBookingsParams.searchfor_surname, 'i'))) {
                            applyFilter = true;
                        }
                    });
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_surname === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };


        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings.filter(booking => filterFlightdate(booking));
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(booking => filterBookingcode(booking));
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(booking => filterInvoiceid(booking));
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(booking => filterSurname(booking));

    }, // eof mut_filterSearchAgencyBookings()










    /***************************************************************************
    * mut_setBookingWireCardEnrollPayment()
    *
    * Desc: Save Wirecard Enroll Payment Response
    * Note:
    *
    */
    mut_setBookingWireCardEnrollPayment: (state, payload) => {

        state.bookingWireCardEnrollPaymentResults = payload;

    }, // eof mut_setBookingWireCardEnrollPayment()





};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * actn_setCurrentLocale()
    *
    * Desc:
    * Note:
    *
    */
    actn_setCurrentLocale: (context, payload) => {

        context.commit('mut_setCurrentLocale', payload); // calling mutation

    }, // eof actn_setCurrentLocale()




    /***************************************************************************
    * Actions: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagSharedShowFlightSearchResults()
    *
    * Desc: ACTION 'Show Flight Search Results Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedShowFlightSearchResults: (context, payload) => {

        context.commit('mut_FlagSharedShowFlightSearchResults', payload); // calling mutation

    }, // eof actn_FlagSharedShowFlightSearchResults()




    /***************************************************************************
    * Actions: Users Search
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingAirports()
    *
    * Desc: ACTION 'SET Search Airports' (Part 1).
    * Note:
    *
    */
    actn_setBookingAirports: (context, payload) => {

        context.commit('mut_setBookingAirports', payload); // calling mutation

    }, // eof actn_setBookingAirports()


    /***************************************************************************
    * actn_setBookingUsersSearchData()
    *
    * Desc: ACTION 'SET Users Search Data' (Part 2).
    * Note: PreFill Cart here too.
    *
    */
    actn_setBookingUsersSearchData: (context, payload) => {

        context.commit('mut_setBookingUsersSearchData', payload); // calling mutation
        context.commit('mut_setBookingPrefillCart', payload); // calling mutation

    }, // eof actn_setBookingUsersSearchData()




    /***************************************************************************
    * Actions: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingFlightSearchResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of FlightSearch.
    *
    */
    actn_setBookingFlightSearchResults: (context, payload) => {

        context.commit('mut_setBookingFlightSearchResults', payload); // calling mutation

    }, // eof actn_setBookingFlightSearchResults()


    /***************************************************************************
    * actn_FlagBookingOutwardFlightSelected()
    *
    * Desc: ACTION 'Outward Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagBookingOutwardFlightSelected: (context, payload) => {

        context.commit('mut_FlagBookingOutwardFlightSelected', payload); // calling mutation

    }, // eof actn_FlagBookingOutwardFlightSelected()


    /***************************************************************************
    * actn_FlagBookingReturnFlightSelected()
    *
    * Desc: ACTION 'Return Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagBookingReturnFlightSelected: (context, payload) => {

        context.commit('mut_FlagBookingReturnFlightSelected', payload); // calling mutation

    }, // eof actn_FlagBookingReturnFlightSelected()


    /***************************************************************************
    * actn_setBookingFlightIdSelectedOutward()
    *
    * Desc: ACTION 'SET Selected Flight Id' Out.
    * Note:
    *
    */
    actn_setBookingFlightIdSelectedOutward: (context, payload) => {

        context.commit('mut_setBookingFlightIdSelectedOutward', payload); // calling mutation

    }, // eof actn_setBookingFlightIdSelectedOutward()


    /***************************************************************************
    * actn_setBookingFlightIdSelectedReturn()
    *
    * Desc: ACTION 'SET Selected Flight Id' Ret.
    * Note:
    *
    */
    actn_setBookingFlightIdSelectedReturn: (context, payload) => {

        context.commit('mut_setBookingFlightIdSelectedReturn', payload); // calling mutation

    }, // eof actn_setBookingFlightIdSelectedReturn()




    /***************************************************************************
    * Actions: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingLockfaresResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of FlightSearch.
    *
    */
    actn_setBookingLockfaresResults: (context, payload) => {

        context.commit('mut_setBookingLockfaresResults', payload); // calling mutation

    }, // eof actn_setBookingFlightSearchResults()


    /***************************************************************************
    * actn_setBookingSrvcsSeatExistOnOut()
    *
    * Desc: ACTION 'SET Service Exists on OUT'.
    * Note: Gets checked in lockfares Response.
    *
    */
    actn_setBookingSrvcsSeatExistOnOut: (context, payload) => {

        context.commit('mut_setBookingSrvcsSeatExistOnOut', payload); // calling mutation

    }, // eof actn_setBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * actn_setBookingSrvcsSeatExistOnRet()
    *
    * Desc: ACTION 'SET Service Exists on RET'.
    * Note: Gets checked in lockfares Response.
    *
    */
    actn_setBookingSrvcsSeatExistOnRet: (context, payload) => {

        context.commit('mut_setBookingSrvcsSeatExistOnRet', payload); // calling mutation

    }, // eof actn_setBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * actn_setBookingValidatePassengersObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setBookingValidatePassengersObject: (context, payload) => {

        context.commit('mut_setBookingValidatePassengersObject', payload); // calling mutation

    }, // eof actn_setBookingValidatePassengersObject()




    /***************************************************************************
    * Actions: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagBookingPaymentIsReadyForOverview()
    *
    * Desc: ACTION 'SET Flag: Payment is ready for Overview'.
    * Note:
    *
    */
    actn_FlagBookingPaymentIsReadyForOverview: (context, payload) => {

        context.commit('mut_FlagBookingPaymentIsReadyForOverview', payload); // calling mutation

    }, // eof actn_FlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * actn_setBookingProcessBookingObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (processBooking).
    * Note:
    *
    */
    actn_setBookingProcessBookingObject: (context, payload) => {

        context.commit('mut_setBookingProcessBookingObject', payload); // calling mutation

    }, // eof actn_setBookingProcessBookingObject()




    /***************************************************************************
    * Actions: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagBookingOverviewIsReadyForProcess()
    *
    * Desc: ACTION 'SET Flag: Overview is ready for Process'.
    * Note:
    *
    */
    actn_FlagBookingOverviewIsReadyForProcess: (context, payload) => {

        context.commit('mut_FlagBookingOverviewIsReadyForProcess', payload); // calling mutation

    }, // eof actn_FlagBookingOverviewIsReadyForProcess()


    /*************************************************************************** 'Version 2 is Tmp only'
    * Call::'/booking/processbooking2/'
    *
    * Desc: (Call) - Process Booking.
    * Note: THIS IS USING 'processBooking2'. An enhanced Copy of Original.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_processBooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/processbooking2/', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // >>> ----------------------------
                        if (response.data.status !== 'KO') {
                            context.commit('mut_setBookingProcessBookingResults', response.data); // save ...
                            eventBus.$emit('readytoshowbookingsconfirmation', response.data); // emit ... 'ready to push 'confirmation' (original)
                            eventBus.$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit ... 'ready to push 'confirmation' (checkout)
                        }

                        // >>> ----------------------------
                        if (response.data.status === 'KO') {
                            eventBus.$emit('errorinconfirmation', response.data); // emit ... 'Error'
                            Vue.prototype.$toasted.global.sdr_app_error({
                                message: response.data.errors[0].errorMessage
                            });
                        }
                        break;
                    default: // 'ERROR'
                        eventBus.$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_processBooking()




    /***************************************************************************
    * Actions: Seats
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * actn_bookingSeatReservationLockingCodeResults()
    *
    * Desc: ACTION 'SET Lockingcodes Results'.
    * Note: Entire Response of /seatplan/lock/ call.
    *
    */
    actn_bookingSeatReservationLockingCodeResults: (context, payload) => {

        context.commit('mut_setBookingSeatReservationLockingCodeResults', payload); // calling mutation

    }, // eof actn_bookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * actn_bookingSeatplanResults()
    *
    * Desc: ACTION 'SET Seatplan Results'.
    * Note: Entire Response of '/seatplan/' Call.
    *
    */
    actn_bookingSeatplanResults: (context, payload) => {

        context.commit('mut_setBookingSeatplanResults', payload); // calling mutation

    }, // eof actn_bookingSeatplanResults()




    /***************************************************************************
    * Actions: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingUpdateCart()
    *
    * Desc: ACTION 'Update Cart'.
    * Note:
    *
    */
    actn_setBookingUpdateCart: (context, payload) => {

        context.commit('mut_setBookingUpdateCart', payload); // calling mutation

    }, // eof actn_setBookingUpdateCart()


    /***************************************************************************
    * actn_setBookingUpdateCartWithSrvcs()
    *
    * Desc: ACTION 'Update Cart' with Services.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithSrvcs: (context, payload) => {

        context.commit('mut_setBookingUpdateCartWithSrvcs', payload); // calling mutation

    }, // eof actn_setBookingUpdateCart()


    /***************************************************************************
    * actn_setBookingUpdateCartWithSeat()
    *
    * Desc: ACTION 'Update Cart' with a Seat.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithSeat: (context, payload) => {

        context.commit('mut_setBookingUpdateCartWithSeat', payload); // calling mutation

    }, // eof actn_setBookingUpdateCartWithSeat()


    /***************************************************************************
    * actn_setBookingUpdateCartWithPaxCredentials()
    *
    * Desc: ACTION 'Update Cart' with Pax Credentials.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithPaxCredentials: (context, payload) => {

        context.commit('mut_setBookingUpdateCartWithPaxCredentials', payload); // calling mutation

    }, // eof actn_setBookingUpdateCartWithPaxCredentials()


    /***************************************************************************
    * actn_setBookingUpdateCartViaDeleteSrvcs()
    *
    * Desc: ACTION 'Update Cart' via DELETE a Service.
    * Note:
    *
    */
    actn_setBookingUpdateCartViaDeleteSrvcs: (context, payload) => {

        context.commit('mut_setBookingUpdateCartViaDeleteSrvcs', payload); // calling mutation

    }, // eof actn_setBookingUpdateCartViaDeleteSrvcs()


    /***************************************************************************
    * actn_setBookingUpdateCartViaDeleteSeat()
    *
    * Desc: ACTION 'Update Cart' via DELETE a Seat.
    * Note: e.g.: { id_pax: pax.id_pax, type: 'return' }
    *
    */
    actn_setBookingUpdateCartViaDeleteSeat: (context, payload) => {

        context.commit('mut_setBookingUpdateCartViaDeleteSeat', payload); // calling mutation

    }, // eof actn_setBookingUpdateCartViaDeleteSeat()




    /***************************************************************************
    * Actions: 'Calls', Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/offers/'
    *
    * Desc: (Call) - ´
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_Offers: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/booking/offers/')
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setOffers', { response: response.data }, { root: true }); // commit into booking state
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_Offers()


    /***************************************************************************
    * Call::'booking/departures/FUE'
    *
    * Desc: (Call) - Geeting Origins Airports
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_DeparturesKeyDes: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('booking/departures/' + payload.destinationOfferAptCode)
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_DeparturesKeyDes', { response: response.data }, { root: true }); // commit into booking state
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_DeparturesKeyDes()


    /***************************************************************************
    * Call::'/booking/listflights/'
    *
    * Desc: (Call) - Get Monthly Offers via 'listflights'
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_ListFlightsMonthlyOffers: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/listflights/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_ListFlightsMonthlyOffers', response.data.listFlightsRS.flts); // commit into booking state
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_ListFlightsMonthlyOffers()


    /***************************************************************************
    * actn_setBookingOffersSelectedDestination()
    *
    * Desc: ACTION 'Save User selected KeyDestination.
    * Note:
    *
    */
    actn_setBookingOffersSelectedDestination: (context, payload) => {

        context.commit('mut_setBookingOffersSelectedDestination', payload); // calling mutation

    }, // eof actn_setBookingOffersSelectedDestination()


    /***************************************************************************
    * actn_setBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: ACTION
    * Note:
    *
    */
    actn_setBookingOffersListFlightsMonthlyOffers: (context, payload) => {

        context.commit('mut_setBookingOffersListFlightsMonthlyOffers', payload); // calling mutation

    }, // eof actn_setBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * actn_setBookingOffersChoosenFlightByUser()
    *
    * Desc: ACTION
    * Note:
    *
    */
    actn_setBookingOffersChoosenFlightByUser: (context, payload) => {

        context.commit('mut_setBookingOffersChoosenFlightByUser', payload); // calling mutation

    }, // eof actn_setBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * Call::'/booking/listflights/'
    *
    * Desc: (Call) - Get Monthly Offers via 'listflights'
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_ListFlightsAfterUserSelectedBestPrice: (context, payload) => {

        let me = this,
            hdrs = '',
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function(element) {
                    // scrolling started
                },
                onDone: function(element) {
                    // scrolling is done
                },
                onCancel: function() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/listflights/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setBookingFlightSearchResults', response.data.listFlightsRS.flts);
                        context.commit('mut_FlagSharedShowFlightSearchResults', true);

                        setTimeout(function() {
                            context.commit('mut_setBookingUpdateCart', { flight: state.bookingOffersChoosenFlightByUser, type: 'outward', modulo: 'booking' });
                            VueScrollTo.scrollTo('#contentElement', 200, options);
                        }, 200);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_ListFlightsAfterUserSelectedBestPrice()


    /***************************************************************************
    * actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc: ACTION 'Show Flight Search Results Section and Best Prices'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel: (context, payload) => {

        context.commit('mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel', payload); // calling mutation

    }, // eof actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()




    /***************************************************************************
    * Actions: 'Calls', Sundair/Agency Login
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagSharedAgencyLoggedIn()
    *
    * Desc: ACTION: Set Flag 'Agency is logged in?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedAgencyLoggedIn: (context, payload) => {

        context.commit('mut_FlagSharedAgencyLoggedIn', payload); // calling mutation

    }, // eof actn_FlagSharedAgencyLoggedIn()


    /***************************************************************************
    * Call::'/rest/info/getagency'
    *
    * Desc: (Call) -
    * Note: Add user/pass in this Call here.
    * Note: Write into LocalStorage. Remember Agency.
    *
    */
    actn_call_GetAgency: (context, payload) => {

        let me = this,
            hdrs = '',
            trsnltd = '',
            agencyObject = {};


        // >>> Send Ajax Request --------------------------
        axios.defaults.headers.username = payload.username; // Add user/pass
        axios.defaults.headers.password = payload.password;

        axios.get('/info/getagency')
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'

                        tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal

                        Vue['ls'].set('agency_username', payload.username, 60 * 60 * 1000); // SuccessFul: => into localStorage, // expiry 1 hour
                        Vue['ls'].set('agency_password', payload.password, 60 * 60 * 1000);
                        Vue['ls'].set('agencyAuthorizationHeader', JSON.stringify(window.btoa(payload.username + ":" + payload.password)), 60 * 60 * 1000); // #795

                        // Vue['ls'].set('agency_commission_amount', response.data.commission.amount, 60 * 60 * 1000);
                        // Vue['ls'].set('agency_commission_type', response.data.commission.type, 60 * 60 * 1000);

                        agencyObject = {
                            firstName: response.data.firstName,
                            lastName: response.data.lastName,
                            address: response.data.address,
                            plz: response.data.postalCode,
                            city: response.data.city,
                            phone: response.data.phone,
                            email: response.data.email,
                            companyName: response.data.companyName,
                            agency_commission_amount: response.data.commission.amount,
                            agency_commission_type: response.data.commission.type,
                            agency_servicecommission_amount: response.data.serviceCommission.amount,
                            agency_servicecommission_type: response.data.serviceCommission.type,
                            idCustomer: response.data.idCustomer,
                            countryCode: response.data.countryCode,
                        };
                        Vue['ls'].set('agency_object', JSON.stringify(agencyObject), 60 * 60 * 1000);


                        Vue.prototype.$toasted.global.sdr_app_info({ // inform
                            message : 'Agency was logged in.'
                        });

                        context.commit('mut_call_GetAgency', { response: response.data }, { root: true }); // commit into booking state
                        context.commit('mut_FlagSharedAgencyLoggedIn', true, { root: true });

                        delete axios.defaults.headers.username; // remove header again
                        delete axios.defaults.headers.password;

                        // reload page
                        setTimeout(function () {
                            location.reload();
                        }, 1000);

                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : trsnltd
                        });

                        delete axios.defaults.headers.username; // remove header again
                        delete axios.defaults.headers.password;
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                delete axios.defaults.headers.username; // remove header again
                delete axios.defaults.headers.password;

                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_GetAgency()


    /***************************************************************************
    * Call::'/booking/getagencybookings'
    *
    * Desc: (Call) -
    * Note:
    *
    */
    actn_call_GetAgencyBookings: (context, payload) => {

        let me = this,
            hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        context.commit('mut_set_AgencyBookingsParams', payload);

        Vue.prototype.$vp_m();
        axios.put('/booking/getagencybookings', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_GetAgencyBookings', { response: response.data }, { root: true }); // commit into booking state
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : trsnltd
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_GetAgencyBookings()


    /***************************************************************************
    * act_set_filterSearchAgencyBookingsParams()
    *
    * Desc: Save Search/Filter Params for Agency Bookings.
    * Note:
    *
    */
    act_set_filterSearchAgencyBookingsParams: (context, payload) => {

        context.commit('mut_set_filterSearchAgencyBookingsParams', { payload: payload, context: context} );

    }, // eo function act_set_filterSearchAgencyBookingsParams()










    /***************************************************************************
    * Actions: 'WireCare Enroll Payment Step'
    ***************************************************************************/
    /***************************************************************************
    * Call::'acm/payment/secuconnect/enroll'
    *
    * Desc: (Call) - WireCard Enroll Payment. ITS NOT WIRTECARD!!!
    * Note: Very special in Error Handling!!!
    *
    */
    actn_call_wireCardEnrollPayment: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/payment/secuconnect/enroll', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'

                        // >>> ----------------------------
                        if (response.data.status === 'KO') {
                            if (response.data.statusReason !== null && response.data.statusReason.length > 0) {
                                Vue.prototype.$toasted.global.sdr_app_error({
                                    message: response.data.statusReason[0].description
                                });
                            }
                            if (response.data.statusReason === null || response.data.statusReason.length === 0) {
                                Vue.prototype.$toasted.global.sdr_app_error({
                                    message: 'Please check your credt card data.'
                                });
                            }
                        }

                        // >>> ----------------------------
                        if (response.data.status !== 'KO') {
                            context.commit('mut_setBookingWireCardEnrollPayment', response.data);
                            eventBus.$emit('readytoshowwirecardmodal');
                        }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_wireCardEnrollPayment()




    /***************************************************************************
    * Call::'booking/prebook'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_preBooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/prebook', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytodostepafterprebook', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_preBooking()


    /***************************************************************************
    * Call::'payment/secuconnect/checkout/'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_checkTransactionId: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('payment/secuconnect/checkout/' + payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // >>> ----------------------------
                        if (response.data.status === 'OK') {
                            eventBus.$emit('readytoprocessbooking', response.data); // emit .. 'ready to push 'confirmation'
                        }

                        // >>> ----------------------------
                        if (response.data.status === 'KO') {
                            eventBus.$emit('errorinconfirmation', response.data);   // emit ... 'Error'
                            Vue.prototype.$toasted.global.sdr_app_error({
                                message: response.data.errors[0].errorMessage
                            });
                        }
                        break;
                    default: // 'ERROR'
                        eventBus.$emit('errorinconfirmation', response.data);       // emit ... 'Error'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_checkTransactionId()


    /***************************************************************************
    * Call::'booking/releaseccbooking/{transactionid}'
    *
    * Desc:
    * Note: This is the 'Cleanup Backend Call'
    *
    */
    actn_call_releaseBooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('booking/releaseccbooking/' + payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // if (response.data.status === 'OK') {
                        //     eventBus.$emit('readytoprocessbooking', response.data); // emit .. 'ready to push 'confirmation'
                        // }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_checkTransactionId()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/booking/booking.js